// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/runner/work/app-v2/app-v2/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/home/runner/work/app-v2/app-v2/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user",
        "layout": false,
        "routes": [
          {
            "path": "/user",
            "routes": [
              {
                "name": "login",
                "path": "/user/login",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/home/runner/work/app-v2/app-v2/src/pages/user/login'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "register",
                "path": "/user/register",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__register' */'/home/runner/work/app-v2/app-v2/src/pages/user/register'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/runner/work/app-v2/app-v2/src/pages/404'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          }
        ]
      },
      {
        "path": "/preview/:encodedParams",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__preview' */'/home/runner/work/app-v2/app-v2/src/pages/preview'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/maintainance",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__maintainance' */'/home/runner/work/app-v2/app-v2/src/pages/maintainance'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/oazalo/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__oazalo' */'/home/runner/work/app-v2/app-v2/src/pages/oazalo'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/index.html",
        "access": "isLandingPage",
        "name": "UCALL - Tổng đài Callbot AI Auto Call",
        "description": "Giải pháp auto call ứng dụng công nghệ AI (trí tuệ nhân tạo) giúp tối ưu chi phí, thời gian cho doanh nghiệp đồng thời đạt hiệu quả cao. Phần mềm auto call của UCALL sẽ giúp doanh nghiệp thuận tiện hơn trong việc tìm kiếm khách hàng, telesales, telemarketing và chăm sóc khách hàng",
        "keywords": "giải pháp auto call, gọi tự động, voicebot, dịch vụ auto call, phần mềm auto call, tự động gọi, phần mềm auto gọi điện",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__index' */'/home/runner/work/app-v2/app-v2/src/pages/new/index'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/",
        "access": "isLandingPage",
        "name": "UCALL - Tổng đài Callbot AI Auto Call",
        "description": "Giải pháp auto call ứng dụng công nghệ AI (trí tuệ nhân tạo) giúp tối ưu chi phí, thời gian cho doanh nghiệp đồng thời đạt hiệu quả cao. Phần mềm auto call của UCALL sẽ giúp doanh nghiệp thuận tiện hơn trong việc tìm kiếm khách hàng, telesales, telemarketing và chăm sóc khách hàng",
        "keywords": "giải pháp auto call, gọi tự động, voicebot, dịch vụ auto call, phần mềm auto call, tự động gọi, phần mềm auto gọi điện",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__index' */'/home/runner/work/app-v2/app-v2/src/pages/new/index'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/solutions",
        "name": "UCALL - Giải pháp callbot AI auto call",
        "access": "isLandingPage",
        "keywords": "dịch vụ auto call, dịch vụ gọi tự động, dich vu auto call, tổng đài auto call (tỉ lệ tăng trưởng cao)",
        "description": "Tổng đài auto call do UCALL cung cấp sẽ giúp doanh nghiệp giảm thiểu chi phí và thời gian; đồng thời dịch vụ auto call cũng sẽ giúp doanh nghiệp tìm kiếm data khách hàng, telesales, telemarketing và chăm sóc khách hàng tiết kiệm thời gian, chi phí nhưng vẫn đảm bảo hiệu quả.",
        "layout": false,
        "routes": [
          {
            "path": "/solutions/telemarketing-telesale-tu-dong",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Telemarketing, Telesale tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale-tu-dong' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale-tu-dong'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/ban-le",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Bán lẻ",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__ban-le' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/ban-le'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/bao-hiem",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Bảo hiểm",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__bao-hiem' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/bao-hiem'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/bat-dong-san",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Bảo hiểm",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__bat-dong-san' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/bat-dong-san'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/giao-duc",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Giáo dục",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__giao-duc' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/giao-duc'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/spa",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Spa",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__spa' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/spa'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/telemarketing-telesale/tai-chinh",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Tài chính",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__telemarketing-telesale__tai-chinh' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/telemarketing-telesale/tai-chinh'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang-tu-dong",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Chăm sóc khách hàng tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang-tu-dong' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang-tu-dong'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang/chot-don-tu-dong",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Chốt đơn tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang__chot-don-tu-dong' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang/chot-don-tu-dong'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang/khao-sat-thi-truong",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Khảo sát thị trường",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang__khao-sat-thi-truong' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang/khao-sat-thi-truong'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang/lay-feedback-khach-hang",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Lấy feedback khách hàng",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang__lay-feedback-khach-hang' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang/lay-feedback-khach-hang'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang/thong-bao-chuong-trinh",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Thông báo chương trình",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang__thong-bao-chuong-trinh' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang/thong-bao-chuong-trinh'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/solutions/cham-soc-khach-hang/nhac-lich-tu-dong",
            "access": "isLandingPage",
            "name": "UCALL - Giải pháp Callbot Nhắc lịch tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__solutions__cham-soc-khach-hang__nhac-lich-tu-dong' */'/home/runner/work/app-v2/app-v2/src/pages/new/solutions/cham-soc-khach-hang/nhac-lich-tu-dong'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          }
        ]
      },
      {
        "path": "/products",
        "name": "UCALL - Giải pháp callbot AI auto call",
        "access": "isLandingPage",
        "keywords": "dịch vụ auto call, dịch vụ gọi tự động, dich vu auto call, tổng đài auto call (tỉ lệ tăng trưởng cao)",
        "description": "Tổng đài auto call do UCALL cung cấp sẽ giúp doanh nghiệp giảm thiểu chi phí và thời gian; đồng thời dịch vụ auto call cũng sẽ giúp doanh nghiệp tìm kiếm data khách hàng, telesales, telemarketing và chăm sóc khách hàng tiết kiệm thời gian, chi phí nhưng vẫn đảm bảo hiệu quả.",
        "layout": false,
        "routes": [
          {
            "path": "/products/callbot-ai-auto-call",
            "name": "UCALL - Giải pháp Callbot AI gọi tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__products__callbot-ai-auto-call' */'/home/runner/work/app-v2/app-v2/src/pages/new/products/callbot-ai-auto-call'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/products/tong-dai-telesale",
            "name": "UCALL - Tổng đài telesale",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__products__tong-dai-telesale' */'/home/runner/work/app-v2/app-v2/src/pages/new/products/tong-dai-telesale'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/products/ulead",
            "name": "UCALL - Giải pháp Tìm kiếm khách hàng Ulead",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__products__ulead' */'/home/runner/work/app-v2/app-v2/src/pages/new/products/ulead'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          }
        ]
      },
      {
        "path": "/about-us",
        "name": "UCALL - Giải pháp callbot AI auto call",
        "access": "isLandingPage",
        "keywords": "dịch vụ auto call, dịch vụ gọi tự động, dich vu auto call, tổng đài auto call (tỉ lệ tăng trưởng cao)",
        "description": "Tổng đài auto call do UCALL cung cấp sẽ giúp doanh nghiệp giảm thiểu chi phí và thời gian; đồng thời dịch vụ auto call cũng sẽ giúp doanh nghiệp tìm kiếm data khách hàng, telesales, telemarketing và chăm sóc khách hàng tiết kiệm thời gian, chi phí nhưng vẫn đảm bảo hiệu quả.",
        "layout": false,
        "routes": [
          {
            "path": "/about-us/introduction",
            "name": "UCALL - Giải pháp Callbot AI gọi tự động",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__introduction' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/introduction'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/hr",
            "name": "UCALL - Tổng đài telesale",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__hr' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/hr'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/recruitment",
            "name": "UCALL - Giải pháp Tìm kiếm khách hàng Ulead",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__recruitment' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/recruitment'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/jdcontentmarketing",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__JdContentMaketing' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/JdContentMaketing'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/jdbusinessdevelopment",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__JdBusinessDevelopment' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/JdBusinessDevelopment'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/jdbusinessdevelopmentHCM",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__JdBusinessDevelopmentHCM' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/JdBusinessDevelopmentHCM'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/jdfontenddeveloper",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__JdFrontEnd' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/JdFrontEnd'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          },
          {
            "path": "/about-us/jdbackenddeveloper",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__about-us__JdBackEnd' */'/home/runner/work/app-v2/app-v2/src/pages/new/about-us/JdBackEnd'), loading: LoadingComponent}),
            "layout": false,
            "exact": true
          }
        ]
      },
      {
        "path": "/pricing",
        "name": "UCALL - Giá và gói bán",
        "description": "UCALL gửi đến khách hàng và doanh nghiệp bảng giá và chi phí sử dụng giải pháp callbot AI auto call của chúng tôi nhằm giúp khách hàng dễ dàng hơn trong việc cân nhắc và lựa chọn gói dịch vụ auto call phù hợp cho doanh nghiệp của mình.",
        "access": "isLandingPage",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__pricing' */'/home/runner/work/app-v2/app-v2/src/pages/new/pricing'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/help",
        "name": "UCALL - Hướng dẫn sử dụng",
        "description": "Hướng dẫn sử dụng Giải pháp AI auto call của UCALL giúp bạn dễ dàng tạo ra những chiến dịch gọi tự động và sử dụng phần mềm auto call được dễ dàng và hiệu quả hơn.",
        "access": "isLandingPage",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__help' */'/home/runner/work/app-v2/app-v2/src/pages/help'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/contact",
        "name": "UCALL - Liên hệ'",
        "access": "isLandingPage",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__contact' */'/home/runner/work/app-v2/app-v2/src/pages/contact'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/order",
        "name": "UCALL - Đặt Hàng'",
        "access": "isLandingPage",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__order' */'/home/runner/work/app-v2/app-v2/src/pages/new/order'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/payment",
        "name": "UCALL - Thanh Toán'",
        "access": "isLandingPage",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__new__payment' */'/home/runner/work/app-v2/app-v2/src/pages/new/payment'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      },
      {
        "path": "/p",
        "layout": false,
        "access": "isLandingPage",
        "routes": [
          {
            "path": "/p/data",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__data' */'/home/runner/work/app-v2/app-v2/src/pages/p/data'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/p/terms",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__terms' */'/home/runner/work/app-v2/app-v2/src/pages/p/terms'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/p/delivery",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__delivery' */'/home/runner/work/app-v2/app-v2/src/pages/p/delivery'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/p/refund",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__refund' */'/home/runner/work/app-v2/app-v2/src/pages/p/refund'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/p/payment",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__payment' */'/home/runner/work/app-v2/app-v2/src/pages/p/payment'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/p/data-storage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__p__data-storage' */'/home/runner/work/app-v2/app-v2/src/pages/p/data-storage'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/confirmation",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__confirmation' */'/home/runner/work/app-v2/app-v2/src/pages/confirmation'), loading: LoadingComponent}),
        "isExact": true,
        "exact": true
      },
      {
        "path": "/onboard",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__onboard' */'/home/runner/work/app-v2/app-v2/src/pages/onboard'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/company/:companyID",
        "menu": {
          "name": "uCall",
          "icon": "",
          "flatMenu": true,
          "hideInMenu": false,
          "hideChildrenInMenu": false
        },
        "routes": [
          {
            "path": "/company/:companyID/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__welcome' */'/home/runner/work/app-v2/app-v2/src/pages/welcome'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/company/:companyID/account",
            "routes": [
              {
                "name": "Đổi Mật Khẩu",
                "path": "/company/:companyID/account/change-password",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__account__change-password' */'/home/runner/work/app-v2/app-v2/src/pages/account/change-password'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/partner",
            "name": "partner",
            "icon": "star",
            "access": "isPartner",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__partner' */'/home/runner/work/app-v2/app-v2/src/pages/partner'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/company/:companyID/customers",
            "name": "customers",
            "icon": "team",
            "access": "canAdmin",
            "routes": [
              {
                "path": "/company/:companyID/customers/groups/",
                "name": "customer_groups",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customers__groups' */'/home/runner/work/app-v2/app-v2/src/pages/customers/groups'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/customers/",
                "name": "customers_list",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customers' */'/home/runner/work/app-v2/app-v2/src/pages/customers'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/customers/imports/",
                "name": "uLeads",
                "access": "isDisplayUleads",
                "icon": "import",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customers__import' */'/home/runner/work/app-v2/app-v2/src/pages/customers/import'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/runner/work/app-v2/app-v2/src/pages/404'), loading: LoadingComponent}),
                "layout": false,
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/scripts",
            "name": "scripts",
            "icon": "file",
            "access": "canAdmin",
            "routes": [
              {
                "path": "/company/:companyID/scripts/",
                "name": "scripts",
                "icon": "file",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scripts' */'/home/runner/work/app-v2/app-v2/src/pages/scripts'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/scripts/scripts/templates",
                "name": "templates",
                "icon": "file",
                "access": "isDev",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scripts__templates' */'/home/runner/work/app-v2/app-v2/src/pages/scripts/templates'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/scripts/:CALL_BOT_SCENARIO_ID/detail",
                "icon": "file",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__scripts__CALL_BOT_SCENARIO_ID__detail' */'/home/runner/work/app-v2/app-v2/src/pages/scripts/[CALL_BOT_SCENARIO_ID]/detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/runner/work/app-v2/app-v2/src/pages/404'), loading: LoadingComponent}),
                "layout": false,
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/campaigns",
            "name": "campaigns",
            "icon": "notification",
            "access": "canAdmin",
            "routes": [
              {
                "path": "/company/:companyID/campaigns/calls",
                "name": "call_campaigns",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__calls' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/calls'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/agents",
                "name": "agents",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__agents' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/agents'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/dials",
                "name": "dials",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__dials' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/dials'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/messages",
                "name": "messages",
                "access": "isDev",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__messages' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/messages'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/dials/:DIAL_CAMPAIGN_ID/detail",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__dials__DIAL_CAMPAIGN_ID__detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/dials/[DIAL_CAMPAIGN_ID]/detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/dials/:DIAL_CAMPAIGN_ID/start",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__dials__DIAL_CAMPAIGN_ID__start' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/dials/[DIAL_CAMPAIGN_ID]/start'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/dials/:DIAL_CAMPAIGN_ID/report",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__dials__DIAL_CAMPAIGN_ID__report' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/dials/[DIAL_CAMPAIGN_ID]/report'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/agents/:AGENT_CAMPAIGN_ID/detail",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__agents__AGENT_CAMPAIGN_ID__detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/agents/[AGENT_CAMPAIGN_ID]/detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/agents/:AGENT_CAMPAIGN_ID/report-detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__agents__AGENT_CAMPAIGN_ID__report-detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/agents/[AGENT_CAMPAIGN_ID]/report-detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/agents/:AGENT_CAMPAIGN_ID/report",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__agents__AGENT_CAMPAIGN_ID__report' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/agents/[AGENT_CAMPAIGN_ID]/report'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/agents/:AGENT_CAMPAIGN_ID/start",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__agents__AGENT_CAMPAIGN_ID__start' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/agents/[AGENT_CAMPAIGN_ID]/start'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/calls/:CAMPAIGN_CALL_ID/detail",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__calls__CAMPAIGN_CALL_ID__detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/calls/[CAMPAIGN_CALL_ID]/detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/calls/:CAMPAIGN_CALL_ID/report",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__calls__CAMPAIGN_CALL_ID__report' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/calls/[CAMPAIGN_CALL_ID]/report'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/calls/:CAMPAIGN_CALL_ID/report-detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__calls__CAMPAIGN_CALL_ID__report-detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/calls/[CAMPAIGN_CALL_ID]/report-detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/messages/:SMS_CAMPAIGN_ID/report",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__messages__SMS_CAMPAIGN_ID__report' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/messages/[SMS_CAMPAIGN_ID]/report'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/campaigns/messages/:SMS_CAMPAIGN_ID/detail",
                "icon": "phone",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__campaigns__messages__SMS_CAMPAIGN_ID__detail' */'/home/runner/work/app-v2/app-v2/src/pages/campaigns/messages/[SMS_CAMPAIGN_ID]/detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/runner/work/app-v2/app-v2/src/pages/404'), loading: LoadingComponent}),
                "layout": false,
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/wallet",
            "name": "my_wallet",
            "icon": "wallet",
            "routes": [
              {
                "path": "/company/:companyID/wallet/deposit",
                "name": "topup",
                "icon": "file",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__deposit' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/deposit'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/deposit/:PRODUCT_SLUG",
                "icon": "file",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__deposit__PRODUCT_SLUG__product' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/deposit/[PRODUCT_SLUG]/product'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/expense-report",
                "name": "expensereport",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__order-history-new' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/order-history-new'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/order-history",
                "name": "orderhistorynew",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__order-history-new2' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/order-history-new2'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/transaction",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__transaction' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/transaction'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/budget-limit",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__budget-limit' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/budget-limit'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/wallet/:PRODUCT_ID/blocks-history",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__wallet__PRODUCT_ID__blocks-history' */'/home/runner/work/app-v2/app-v2/src/pages/wallet/[PRODUCT_ID]/blocks-history'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/notification",
            "name": "notification",
            "icon": "bell",
            "access": "canAdmin",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__notification' */'/home/runner/work/app-v2/app-v2/src/pages/notification'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/company/:companyID/caller",
            "name": "history",
            "icon": "phone",
            "access": "canAdmin",
            "routes": [
              {
                "path": "/company/:companyID/caller/caller/history",
                "name": "calls_history",
                "icon": "wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__caller__history' */'/home/runner/work/app-v2/app-v2/src/pages/caller/history'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/company/:companyID/settings_new",
            "name": "new_settings",
            "icon": "setting",
            "access": "canAdmin",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settings__new' */'/home/runner/work/app-v2/app-v2/src/pages/settings/new'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/company/:companyID/help",
            "name": "help",
            "icon": "questionCircle",
            "access": "displayHelp",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__uhelp' */'/home/runner/work/app-v2/app-v2/src/pages/uhelp'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/company/:companyID/affiliate",
            "name": "affiliate",
            "icon": "gift",
            "access": "displayHelp",
            "routes": [
              {
                "path": "/company/:companyID/affiliate/invite",
                "name": "invite",
                "icon": "star",
                "access": "displayHelp",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__invite' */'/home/runner/work/app-v2/app-v2/src/pages/invite'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company/:companyID/affiliate/customers",
                "name": "customers",
                "access": "displayHelp",
                "icon": "star",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__affiliate__customers' */'/home/runner/work/app-v2/app-v2/src/pages/affiliate/customers'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/refresh",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__refresh' */'/home/runner/work/app-v2/app-v2/src/pages/refresh'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/runner/work/app-v2/app-v2/src/pages/404'), loading: LoadingComponent}),
        "layout": false,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
